import React from 'react';
import { IAppointment } from '../../types/appointment';
import Countdown from 'react-countdown';
import ErrorBoundary from '../../lib/ErrorBoundary/ErrorBoundary';
import dayjs from 'dayjs';
import { AlertBar } from '../../flayr-components/AlertBar/AlertBar';
import classNames from 'classnames';

interface IProfileAlertBarProps {
  status?: string;
  offerExpiryTime?: string;
  appointment?: IAppointment;
  onClick?: (e?: any) => void;
  onCountdownComplete?: (e?: any) => void;
  onLearnMore?: (e?: any) => void;
}

const ProfileAlertBar: React.FC<React.PropsWithChildren<React.PropsWithChildren<IProfileAlertBarProps>>> = ({
  status = '',
  offerExpiryTime,
  appointment,
  onClick,
  onCountdownComplete,
  onLearnMore,
}) => {
  const alertContentMapping = {
    none: {
      type: 'success',
      title: <div className="py-3">Free lashes with every makeup</div>,
      subTitle: (
        <span className="hidden underline cursor-pointer">Learn More</span>
      ),
    },
    requested: {
      type: 'secondary',
      title: 'Waiting on Artist to Respond',
      subTitle: 'We will email & text you once the artist responds',
    },
    booked: {
      type: 'success',
      title: 'Congrats on your booking',
      subTitle: 'A booking confirmation email has been sent',
    },
    rescheduleRequested: {
      type: 'success',
      title: 'Congrats on your booking',
      subTitle: 'A booking confirmation email has been sent',
    },
    rescheduleOffered: {
      type: 'danger',
      title: 'Congrats on your booking',
      subTitle: 'A booking confirmation email has been sent',
    },
    offerExpired: {
      type: 'danger',
      title: 'Offer Expired',
      subTitle: 'Request again',
    },
    declined: {
      type: 'dark',
      title: 'Unavailable',
      subTitle: 'Look for other providers',
    },
    bookedOut: {
      type: 'dark',
      title: 'Unavailable',
      subTitle: 'Look for other providers',
    },
    dismissed: {
      type: 'dark',
      title: 'Unavailable',
      subTitle: 'Look for other providers',
    },
    expired: {
      type: 'dark',
      title: 'Unavailable',
      subTitle: 'Look for other providers',
    },
    deleted: {
      type: 'dark',
      title: 'Unavailable',
      subTitle: 'Look for other providers',
    },
    inReview: {
      type: 'success',
      title: 'Congrats on your booking',
      subTitle: 'A booking confirmation email has been sent',
    },
    completed: {
      type: 'success',
      title: 'Thank you',
      subTitle: 'Your review has been submitted',
    },
    reviewed: {
      type: 'success',
      title: 'Thank you',
      subTitle: 'Your review has been submitted',
    },
    undefined: {
      type: '',
      title: '',
      subTitle: '',
    },
  };

  function getContentForOffered(expiryDate, onCompleted?) {
    return {
      type: 'danger',
      title: (
        <span>
          Offer expires in{' '}
          <Countdown
            date={new Date(expiryDate)}
            onComplete={onCompleted}
            // date={new Date(dayjs().add(4, 's').format())}
            renderer={({ hours, minutes, seconds }) => (
              <>
                {hours}h {minutes}m {seconds}s
              </>
            )}
          />
        </span>
      ),
      subTitle: (
        <div className="mt-1 leading-none " onClick={onLearnMore}>
          {/* This is not a reservation. <br />
        <span>Prices are likely to rise. Lock in your price today.</span> */}
          Covid Cancellation Policy.{' '}
          <span className="underline cursor-pointer">Learn more</span>
        </div>
      ),
    };
  }
  if (appointment) {
    status = appointment?.status || '';
    offerExpiryTime = appointment?.tracking?.timeOfferExpires;
  }
  const content =
    (['offered', 'timeChangeRequested', 'rescheduleOffered'].includes(status) &&
      getContentForOffered(offerExpiryTime, onCountdownComplete)) ||
    (alertContentMapping[status] as any);

  return (
    (!!content && (
      <ErrorBoundary info="component: alert bar">
        <AlertBar
          type={content?.type}
          titleClassName="leading-tight font-medium lg:text-center"
          title={content?.title}
          subTitle={content?.subTitle}
          subTitleClassName="text-sm lg:text-center"
          onClick={onClick}
          // className={classNames({ 'sticky top-0': status === 'offered' })}
        />
      </ErrorBoundary>
    )) ||
    null
  );
};
export default ProfileAlertBar;
